import client from './client';

export const searchUsers = async (query) => {
    const response = await client.post('/social/search_users', { q: query });
    return response.data;
};

export const getFriends = async () => {
    const response = await client.get('/social/get_friends');
    return response.data;
};

export const getPendingSentRequests = async () => {
    const response = await client.get('/social/pending_sent_requests');
    return response.data;
};

export const getPendingReceivedRequests = async () => {
    const response = await client.get('/social/pending_received_requests');
    return response.data;
};

export const sendFriendRequest = async (recipId) => {
    const response = await client.post('/social/send_friend_request', { recip_id: recipId });
    return response.data;
};

export const respondFriendRequest = async (senderId, status) => {
    const response = await client.post('/social/respond_friend_request', {
        sender_id: senderId,
        status,
    });
    return response.data;
};

export const deleteFriend = async (friendId) => {
    const response = await client.post('/social/delete_friend', { friend_id: friendId });
    return response.data;
};

export const blockFriend = async (friendId) => {
    const response = await client.post('/social/block_friend', { friend_id: friendId });
    return response.data;
};

export const deleteFriendRequest = async (recipId) => {
    const response = await client.post('/social/delete_friend_request', { recip_id: recipId });
    return response.data;
};
